module.exports = __webpack_public_path__ + "static/media/Toilet.afcfbd7f.png";